import { useState } from 'react';

/**
 * A company's logo where its name would be. A wide logo (a wordmark) stands
 * alone; a square-ish one (a symbol) gets the name beside it, so the name is
 * always readable, in the theme's text colour.
 */
export function LogoMark({ name, logoUrl }: { name: string; logoUrl: string }) {
  const [symbol, setSymbol] = useState(false);
  return (
    <>
      <img
        src={logoUrl}
        alt={symbol ? '' : name}
        className={symbol ? 'logo-symbol' : undefined}
        onLoad={(e) => {
          const { naturalWidth: width, naturalHeight: height } = e.currentTarget;
          setSymbol(width > 0 && height > 0 && width < height * 1.6);
        }}
      />
      {symbol && <span>{name}</span>}
    </>
  );
}
